import { ReactNode } from 'react';

import * as S from './style';

const PageContentWrapper = ({ children }: { children: ReactNode }) => {
  return <S.ContentWrapper>{children}</S.ContentWrapper>;
};

export default PageContentWrapper;
